export class VerifyOtpResponseBody {
    loginId: string;
    status: string;
    data: boolean;
}
